import { ReactElement, useEffect } from 'react';
import ReactGA from 'react-ga4';

import { useAuthUser } from 'auth/hooks';

import { usePageTracking } from './usePageTracking';

export const GoogleAnalytics = ({ children }: { children?: ReactElement }) => {
  const { user } = useAuthUser();

  const isEnabled = Boolean(process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED);

  const globalCode = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE;
  const instanceCode = user?.instanceSettings?.analyticsId;

  const code = instanceCode || globalCode;

  usePageTracking({ isEnabled });

  useEffect(() => {
    if (!isEnabled || !code) {
      return;
    }

    ReactGA.initialize(code);
  }, [isEnabled, code]);

  return children ?? null;
};
